// extracted by mini-css-extract-plugin
module.exports = {"chevron":"countryCode_chevron__6ZMgy","rotate":"countryCode_rotate__t3mC2"};